// extracted by mini-css-extract-plugin
export default {"BlaBlaWrapper":"styles_BlaBlaWrapper__lzpRf"};